<template>
  <div
    class="content-privacy-policy-web"
    v-html="$t('owork_base.owork_user_policy.content_web', { registeredAddress, policySubject, postCode, baseDomain })"
  ></div>
</template>

<script lang="ts" setup>
  import { useSharedBrand } from '@/core/compositions/UseBrand'

  const { registeredAddress, policySubject, postCode, baseDomain } = useSharedBrand()
</script>
<style lang="stylus">
  .content-privacy-policy-web
    padding 0px 32px 50px
    overflow-y auto
    height 530px
    font-size 14px
    color default_color
    & > div
      margin-top 8px
      line-height 23px
    .divide-space
      &:last-of-type
        margin-top 20px
    .sub-title
      font-weight bolder_font_weight
      line-height 20px
    .bolder-text
      font-weight bolder_font_weight
    .align-right-text
      text-align right
    .underline-text
      text-decoration underline

  @import '../../styles/h5Adaptive/settingModal.styl'
</style>
